// import localMixin from "./Mixins/DailyReport";
import axios from "axios";
import moment from "moment";
import TaskStatusAddComponent from "../../components/TaskStatusAddComponent.vue";
import TaskCommentComponent from "../../components/TaskCommentDialogComponent.vue";
import TaskAddToComponent from "../../components/TaskAddToComponent.vue";
import AuditLogComponent from "../../components/AuditLogComponent.vue";
// import Multiselect from "@vueform/multiselect";
import Swal from "sweetalert2";

export default {
  name: "TaskTable",
  props: ["visitId", "FetchTableData", "patientId"],
  components: {
    TaskStatusAddComponent,
    TaskCommentComponent,
    TaskAddToComponent,
    AuditLogComponent,
    // Multiselect,
  },

  data() {
    return {
      userid: 0,
      displayAuditLog: false,
      AddTaskStatusModal: false,
      currentPatientTask: {},
      interval: 0,
      TimerObject: {},
      pageSize: 50,
      pageNumber: 1,
      totalRows: 0,
      totalPages: 10,
      initDatePR: "",
      showPagesMin: 1,
      showPagesMax: 5,
      startDatePR: {},
      endDatePR: {},
      Users: [],
      Tasks: [],
      TasksStatus: [],
      showModal: false,
      SelectedUsers: [],
      SelectedTasks: [],
      SelectedTasksStatus: [],
      PatientTasks: [],
      PatientTask: null,
      sortCol: 0,
      sortOption: true,
      taskComment: false,
      pId: this.patientId,
    };
  }, // data

  methods: {
    convertItInSortAndGroupList(taskStatusList) {
      const sortedStatusList = taskStatusList.sort(
        ({ closeTask: a }, { closeTask: b }) => (a === b ? 0 : a ? 1 : -1),
      );

      const groupedStatusList = sortedStatusList.reduce(
        (groups, { taskStatusId, statusName, closeTask }) => {
          const groupLabel = closeTask === false ? "Open" : "Closed";
          const group = groups.find(({ label }) => label === groupLabel);
          if (group) {
            group.items.push({ taskStatusId, statusName });
          } else {
            groups.push({
              label: groupLabel,
              items: [{ taskStatusId, statusName }],
            });
          }
          return groups;
        },
        [],
      );

      return groupedStatusList;
    },

    TaskNameUpdatedIcon(e, taskName, pt) {
      pt.inputNameIcon = true;
    },
    showAuditLog(pt) {
      this.displayAuditLog = true;
      this.$nextTick(() => {
        try {
          this.$refs.auditLogComponent.loadInitVisit(pt.visitId);
        } catch (err) {
          console.log(err.message);
          return -1;
        }
      });
    },
    getAuditLogByVisitTaskIdAndTaskId(pt) {
      this.displayAuditLog = true;
      this.$nextTick(() => {
        try {
          this.$refs.auditLogComponent.getAuditLogByVisitTaskIdAndTaskId(
            pt.visitId,
            0,
            pt.taskID,
          );
        } catch {
          return -1;
        }
      });
    },
    getComment(id, pt) {
      this.PatientTask = pt;

      this.taskComment = true;
      this.$nextTick(() => {
        this.$refs.taskCommentCom.GetComment(id);
      });
    },
    CloseTaskCommentModal() {
      this.taskComment = false;
    },
    datePickerPR() {
      const self = this;
      $('input[name="daterangePR"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          self.startDatePR = new Date(start);
          self.endDatePR = new Date(end);
          self.initDatePR =
            self.dateToMDY(self.startDatePR) +
            " - " +
            self.dateToMDY(self.endDatePR);
        },
      );
    },
    loadInit() {
      this.intDummyComm();
      this.getTableData();
    },
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      //show pagination
      if (this.showPagesMax / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
      } else if (this.showPagesMin / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
        if (this.showPagesMax < 5) {
          this.showPagesMax = 5;
        }
      } else {
        this.showPagesMin = 1;
        this.showPagesMax = 5;
      }
      //show pagination
      this.loadInit();
    },
    async getTableDataA(VisitId) {
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.pageNumber = this.pageNumber;
      this.visitId = VisitId;
      const userIds = this.SelectedUsers.map(function (x) {
        return x.userId;
      });
      const taskIds = this.SelectedTasks.map(function (x) {
        return x.taskID;
      });
      const statusIds = this.SelectedTasksStatus.map(function (x) {
        return x.id;
      });
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      this.dummyComm.visitId = VisitId;
      const obj = {
        userIds: userIds,
        taskIds: taskIds,
        statusIds: statusIds,
        DC: this.dummyComm,
        startDate: this.startDatePR,
        endDate: this.endDatePR,
        sortCol: this.sortCol,
        sortOption: this.sortOption,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetAllPatientTasksTable",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.PatientTasks = myData.data;

            this.totalRows = this.PatientTasks[0].total;
            this.totalPages = this.PatientTasks[0].totalPages;
            if (this.pageNumber > this.totalPages) this.pageNumber = 1;
          } else {
            this.error;
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
          this.$nextTick(() => {
            $("#taskidmodal").on("shown.bs.modal", function (e) {
              $(document).off("focusin.modal");
            });
          });
        });
    },
    async getTableData() {
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.pageNumber = this.pageNumber;
      const userIds = this.SelectedUsers.map(function (x) {
        return x.userId;
      });
      const taskIds = this.SelectedTasks.map(function (x) {
        return x.taskID;
      });
      const statusIds = this.SelectedTasksStatus.map(function (x) {
        return x.id;
      });
      var loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.tableLoad,
        color: "#03a9f3",
      });
      this.dummyComm.visitId = this.visitId;
      const obj = {
        userIds: userIds,
        taskIds: taskIds,
        statusIds: statusIds,
        DC: this.dummyComm,
        startDate: this.startDatePR,
        endDate: this.endDatePR,
        sortCol: this.sortCol,
        sortOption: this.sortOption,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetAllPatientTasksTable",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.PatientTasks = myData.data;

            this.totalRows = this.PatientTasks[0].total;
            this.totalPages = this.PatientTasks[0].totalPages;
            if (this.pageNumber > this.totalPages) this.pageNumber = 1;
          } else {
            this.error;
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          loader.hide();
          this.$nextTick(() => {
            $("#taskidmodal").on("shown.bs.modal", function (e) {
              $(document).off("focusin.modal");
            });
          });
        });
    },
    orderBy(sortCol) {
      if (sortCol == this.sortCol) {
        if (this.sortOption == false) {
          this.sortOption = true;
        } else {
          this.sortOption = false;
        }
      } else {
        this.sortOption = true;
      }
      this.sortCol = sortCol;
      this.getTableData();
    },
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ChangeTaskStatus(pt, taskStatus) {
      //taskStatus is zero call modal
      if (taskStatus == 0) {
        this.currentPatientTask = pt;
        this.AddTaskStatusModal = true;
      } //call axios
      else {
        console.log(taskStatus);
        this.ChangeTaskStatusAxios(pt, taskStatus, 0);
      }
    },
    async ChangeTaskStatusAxios(pt, taskStatus, what) {
      this.intDummyComm();
      this.dummyComm.patientId = pt.patientId;
      const obj = {
        DC: this.dummyComm,
        TaskStatus: taskStatus,
        VisitTaskId: pt.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/PostAssignStatusToTask",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to update information");
            this.getTableData();
          }
        })
        .finally(() => {
          if (what !== 0) {
            this.getTableData();
          }
          this.FetchTableData();
          this.ResetLogoutTime();
        });
    },
    AddRemoveUser(e, userSelected, userList, pt) {
      pt.loading = true;
      this.AddRemoveUserAxios(userSelected, userList, pt);
    },
    async AddRemoveUserAxios(userSelected, userList, pt) {
      this.intDummyComm();
      const obj = {
        DC: this.dummyComm,
        UserIds: userSelected,
        VisitTaskId: pt.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/TaskAssignAddRemoveUser",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to undate information");
            this.getTableData();
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          pt.loading = false;
        });
    },
    ChangeTaskDueDateIcon(pt, dueDate) {
      pt.dateChangeIcon = true;
    },
    ChangeTaskDueDate(pt, dueDate) {
      this.ChangeTaskDueDateAxios(pt, dueDate);
    },
    async ChangeTaskDueDateAxios(pt, dueDate) {
      this.intDummyComm();
      this.dummyComm.patientId = pt.patientId;

      const obj = {
        DC: this.dummyComm,
        DueDate: dueDate,
        VisitTaskId: pt.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/PostUpdateDueDateToTask",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to update information");
            this.getTableData();
          }
        })
        .finally(() => {
          pt.dateChangeIcon = false;
          this.ResetLogoutTime();
        });
    },
    TaskNameUpdatedkeyPress(e, taskName) {
      console.log(e);
    },
    async TaskNameUpdated(e, taskName, pt) {
      debugger;
      if (taskName.length > 250 || taskName.length == 0) {
        e.preventDefault();
        return;
      }
      this.intDummyComm();
      this.dummyComm.patientId = pt.patientId;

      const obj = {
        DC: this.dummyComm,
        TaskName: taskName,
        VisitTaskId: pt.visitTaskId
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/PostUpdateTaskNamePatient",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to update information");
            this.getTableData();
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          pt.inputNameIcon = false;
        });
    },
    ShowTaskAddTo() {
      this.showModal = true;
    },
    CloseTaskAddTo() {
      this.showModal = false;
    },
    closeTaskStatus() {
      this.AddTaskStatusModal = false;
    },
    sortUsersSelected(userList, userSelected) {
      //console.log(userList,userSelected);
      userSelected.forEach((x) => {
        var item = userList.find((i) => i.userId == x);
        var index = userList.findIndex((i) => i.userId == x);
        if (item !== undefined) {
          userList.splice(index, 1);
          userList.splice(0, 0, item);
        }
      });
    },
    deleteVisitTaskSwal(pt) {
      Swal.fire({
        icon: "error",
        title: "Are you sure?",
        text: "you want to delete this task and any information related to it.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          this.deleteVisitTaskAxios(pt);
        }
      });
    },
    async deleteVisitTaskAxios(pt) {
      this.intDummyComm();
      const obj = {
        DC: this.dummyComm,
        VisitTaskId: pt.visitTaskId,
        TaskId: pt.taskID,
        PatientId: pt.patientId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/DeletePatientTask",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.successToast();
          } else {
            this.errorToast("Unable to update information");
            this.getTableData();
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          this.getTableData();
        });
    },
  }, // methods

  computed: {}, // computed

  watch: {
    initDatePR: function () {
      this.loadInit();
      // console.log(this.initDatePR);
    },
  }, //watch

  mounted() {
    this.intDummyComm();
    const str = localStorage.OSversion;
    const arr = str.split(this.UKEY);
    this.userid = arr[0] * 1;
    this.StartLogoutTime();
    const dd = new Date();
    dd.setDate(dd.getDate() - 30);

    this.startDatePR = dd;
    this.endDatePR = new Date();
    this.initDatePR =
      this.dateToMDY(this.startDatePR) + " - " + this.dateToMDY(this.endDatePR);
  }, // mounted
};
